export default "__VITE_ASSET__8c628133__"